export default {
	background: "https://assets.swoogo.com/uploads/full/1498320-61aa5815cf59a.jpeg",
	extras: (
		<iframe
			className="social-media-wall"
			style="height: 18.2%; left: 11.6%; top: 5.6%; width: 16%; position: absolute; cursor: pointer; border: none;"
			src="https://www.youtube.com/embed/ScMzIvxBSi4"
			allowfullscreen
		/>
	),
	links: [
		{
			label: "Networking Room",
			href: "/networking",
			height: "20.6%",
			left: "79.8%",
			top: "43.7%",
			width: "13.0%",
		},
		{
			onClick: () => window.smartsupp("chat:open"),
			label: "Help Desk",
			width: "8.9%",
			height: "7.0%", 
			left: "50.7%",
			top: "68.0%",
		},
		{
			onClick: () => openLibrary(),
			label: "On Demand Library",
			width: "10.4%",
			height: "22.9%",
			left: "1.3%",
			top: "56.5%",
		},
	],
	name: "lobby",
}
